import SourceCode from "./SourceCode";

export default class SourceCodes {

    public static fromString(code: string): SourceCode {
        const codeUpper = code.toUpperCase();
        const codeKey = Object.keys(SourceCode)
                .find(key => key.toUpperCase() === codeUpper);
        if (codeKey === undefined) {
            throw new Error('Unknown source code: ' + code);
        }
        return SourceCode[codeKey];
    }
}
